import {computed, inject, Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {lastValueFrom} from 'rxjs';
import {UserInfo} from '../forms/file-online-v2/models/UserInfo';
import {injectQuery} from '@tanstack/angular-query-experimental';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly user = computed<UserInfo | null>(() => this.userQuery.data() ?? null);
  readonly isLoggedIn = computed(() => this.user() !== null);
  private readonly apiService = inject(ApiService);

  userQuery = injectQuery(() => ({
    queryKey: ['user'],
    queryFn: () => lastValueFrom(this.apiService.userInfo()),
    retry: 3,
    retryDelay: (attemptIndex) => 1000 * Math.pow(2, attemptIndex), // 1s, 2s, 4s
  }))
}
